module.exports = __webpack_public_path__ + "h5/img/gold-shard.6aa8ac3e.png";